import React, { lazy, Fragment } from 'react';
import { FormStateChangeNotifier } from '../form';
import { useIsInForm } from '../utils/useIsInForm';
import { Label } from '../label';
import { FieldContainer } from '../utils/FieldContainer';
var AkFormField = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Field
    };
  });
});
var AKTextArea = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.textarea' */
  '@atlaskit/textarea');
});
var AKErrorMessage = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.ErrorMessage
    };
  });
});
var AKHelperMessage = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.HelperMessage
    };
  });
});
var validate = function validate(value) {
  return !value ? 'EMPTY' : undefined;
};
export var TextArea = function TextArea(props) {
  var _ref = props.forgeDoc.props,
    name = _ref.name,
    label = _ref.label,
    defaultValue = _ref.defaultValue,
    isMonospaced = _ref.isMonospaced,
    isRequired = _ref.isRequired,
    description = _ref.description,
    placeholder = _ref.placeholder,
    spellCheck = _ref.spellCheck,
    _onChange = _ref.onChange,
    value = _ref.value;
  var isInForm = useIsInForm();
  if (!isInForm) {
    return /*#__PURE__*/React.createElement(FieldContainer, null, /*#__PURE__*/React.createElement(Label, {
      name: name,
      isRequired: isRequired,
      label: label
    }), /*#__PURE__*/React.createElement(AKTextArea, {
      name: name,
      appearance: "standard",
      resize: "smart",
      minimumRows: 2,
      defaultValue: defaultValue,
      isMonospaced: isMonospaced,
      placeholder: placeholder,
      spellCheck: spellCheck,
      onChange: function onChange(event) {
        _onChange === null || _onChange === void 0 || _onChange(event.target.value);
      },
      value: value
    }), description && /*#__PURE__*/React.createElement(AKHelperMessage, null, description));
  }
  return /*#__PURE__*/React.createElement(FieldContainer, null, /*#__PURE__*/React.createElement(AkFormField, {
    name: name,
    label: label,
    defaultValue: defaultValue,
    isRequired: isRequired,
    validate: isRequired ? validate : undefined
  }, function (_ref2) {
    var fieldProps = _ref2.fieldProps,
      error = _ref2.error;
    var id = fieldProps.id,
      isDisabled = fieldProps.isDisabled,
      isRequired = fieldProps.isRequired,
      isInvalid = fieldProps.isInvalid,
      onBlur = fieldProps.onBlur,
      onFocus = fieldProps.onFocus,
      ariaInvalid = fieldProps['aria-invalid'],
      ariaLabelledBy = fieldProps['aria-labelledby'];
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(FormStateChangeNotifier, {
      name: name,
      value: fieldProps.value
    }), /*#__PURE__*/React.createElement(AKTextArea, {
      id: id,
      isDisabled: isDisabled,
      isRequired: isRequired,
      isInvalid: isInvalid,
      onBlur: onBlur,
      onFocus: onFocus,
      value: fieldProps.value,
      name: fieldProps.name,
      onChange: function onChange(event) {
        fieldProps.onChange(event);
        _onChange && _onChange(event.target.value);
      },
      appearance: "standard",
      resize: "smart",
      minimumRows: 2,
      isMonospaced: isMonospaced,
      placeholder: placeholder,
      spellCheck: spellCheck,
      "aria-invalid": ariaInvalid,
      "aria-labelledby": ariaLabelledBy
    }), error === 'EMPTY' && /*#__PURE__*/React.createElement(AKErrorMessage, null, "This field is required."), description && /*#__PURE__*/React.createElement(AKHelperMessage, null, description));
  }));
};